
export default {
  name: 'ColumnsSlice',
  props: ['slice'],
  computed:{
    columnClass(){
      return this.slice.items.length % 2 === 0 ? 'col-lg-6' : 'col-lg-4'
    }
  }
}
